import Decimal from 'decimal.js'

export const getAssignedAmount = (selectedTransactions) => {
  const rawAssignedAmount = selectedTransactions.reduce((assignedAmount, transaction) => {
    const { outstandingAmount } = transaction

    return assignedAmount.plus(outstandingAmount)
  }, new Decimal(0))

  return rawAssignedAmount.toDP(2)
}

export default getAssignedAmount
